import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import useAuthStore from './store/authStore';
import Layout        from './components/Layout';
import Login         from './pages/Login';
import Dashboard     from './pages/Dashboard';
import DossierList   from './pages/DossierList';
import DossierCreate from './pages/DossierCreate';
import DossierDetail from './pages/DossierDetail';
import Profile       from './pages/Profile';
import RapportExpertise from './pages/RapportExpertise';
import LandingPage from './pages/LandingPage';


const theme = createTheme({
    palette: {
        primary:    { main: '#1a3c5e' },
        secondary:  { main: '#c8a951' },
        background: { default: '#f5f7fa' },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", sans-serif',
    },
    shape: { borderRadius: 10 },
});

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('access_token');
    return token ? children : <Navigate to="/login" />;
};

export default function App() {
    const fetchProfile = useAuthStore((s) => s.fetchProfile);

    useEffect(() => {
        if (localStorage.getItem('access_token')) {
            fetchProfile();
        }
    }, [fetchProfile]);

return (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <BrowserRouter>
                <Routes>

                    {/* ── Publiques ── */}
                    <Route path="/"      element={<LandingPage />} />
                    <Route path="/login" element={<Login />} />

                    {/* ── Protégées (Layout commun) ── */}
                    <Route element={
                        <PrivateRoute>
                            <Layout />
                        </PrivateRoute>
                    }>
                        <Route path="/dashboard"              element={<Dashboard />} />
                        <Route path="/dossiers"               element={<DossierList />} />
                        <Route path="/dossiers/nouveau"       element={<DossierCreate />} />
                        <Route path="/dossiers/:id"           element={<DossierDetail />} />
                        <Route path="/dossiers/:id/rapport"   element={<RapportExpertise />} />
                        <Route path="/profil"                 element={<Profile />} />
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" />} />

                </Routes>
            </BrowserRouter>
        </SnackbarProvider>
    </ThemeProvider>
);
}